import TopNavigation from "app/components/_molecules/TopNavigation";
import { mobileModeMaxWidthClassName, shouldShowMobileMode } from "configs/mobile-view-config/ControlMobileView";

interface Props {
  children: React.ReactNode;
  className?: string;
}
const GlobalLayout = ({ children, className = "" }: Props) => {
  return (
    <div style={{ margin: "0 auto", paddingTop: "32px" }} className={`${shouldShowMobileMode ? mobileModeMaxWidthClassName : ""}`}>
      <div style={{ zIndex: "1000", position: "fixed", top: "0", left: "50%", transform: "translateX(-50%)" }} className={` ${shouldShowMobileMode ? mobileModeMaxWidthClassName : ""} w-full`}>
        <TopNavigation />
      </div>
      <div className={` ${className}`}>{children}</div>
    </div>
  );
};
export default GlobalLayout;
